import React from 'react';
import { Card, Tag, Button, Space, Typography } from 'antd';
import { DeleteOutlined, FieldBinaryOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FieldCard = ({ field, onRemove }) => {
  const getFieldIcon = (type) => {
    switch (type) {
      case 'string':
        return '📝';
      case 'number':
        return '🔢';
      case 'date':
        return '📅';
      case 'boolean':
        return '✅';
      case 'relation':
        return '🔗';
      default:
        return '📄';
    }
  };

  const getFieldColor = (type) => {
    switch (type) {
      case 'string':
        return 'blue';
      case 'number':
        return 'green';
      case 'date':
        return 'orange';
      case 'boolean':
        return 'purple';
      case 'relation':
        return 'cyan';
      default:
        return 'default';
    }
  };

  return (
    <Card
      size="small"
      style={{
        minWidth: '200px',
        position: 'relative',
        border: '1px solid #e8e8e8',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
      bodyStyle={{ padding: '12px' }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
          <Space align="center">
            <span style={{ fontSize: '16px' }}>{getFieldIcon(field.type)}</span>
            <Text strong style={{ fontSize: '14px' }}>{field.label}</Text>
          </Space>
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            onClick={onRemove}
            danger
            style={{ padding: '2px' }}
          />
        </Space>

        <Space size="small">
          <Tag size="small" color={getFieldColor(field.type)}>
            {field.type}
          </Tag>
          {field.entityType && (
            <Tag size="small" color="geekblue">
              {field.entityType}
            </Tag>
          )}
        </Space>

        <Text type="secondary" style={{ fontSize: '12px' }}>
          {field.name}
        </Text>
      </Space>
    </Card>
  );
};

export default FieldCard;